/**
 * Generates a random password based on specified options.
 *
 * @param {number} length - The length of the password to generate.
 * @param {Array<string>} options - An array of options for password composition.
 *
 * @returns {string} A randomly generated password.
 */
export const generatePassword = (length: number, options: Array<string>) => {
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numberChars = '0123456789';
  const symbolChars = '!@#$%^&*()_+[]{}|;:,.<>?';

  let allChars = '';
  let selectedChars = '';

  if (options.includes('lowercase')) {
    allChars += lowercaseChars;
    selectedChars += lowercaseChars.charAt(
      Math.floor(Math.random() * lowercaseChars.length),
    );
  }

  if (options.includes('uppercase')) {
    allChars += uppercaseChars;
    selectedChars += uppercaseChars.charAt(
      Math.floor(Math.random() * uppercaseChars.length),
    );
  }

  if (options.includes('numbers')) {
    allChars += numberChars;
    selectedChars += numberChars.charAt(
      Math.floor(Math.random() * numberChars.length),
    );
  }

  if (options.includes('symbols')) {
    allChars += symbolChars;
    selectedChars += symbolChars.charAt(
      Math.floor(Math.random() * symbolChars.length),
    );
  }

  let password = selectedChars;

  for (let i = selectedChars.length; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * allChars.length);

    password += allChars.charAt(randomIndex);
  }

  return password;
};
